/**
 * AccessDenied — /erisim-yok
 *
 * Non-admin kullanıcı whitelist'inde olmayan bir modüle girmeye çalıştığında
 * ModuleGuard tarafından buraya yönlendirilir.
 */
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { ShieldWarning, House, EnvelopeSimple } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { findModuleBySlug } from "@/lib/moduleMenus";

export default function AccessDenied() {
  const nav = useNavigate();
  const loc = useLocation();
  const slug = loc.state?.slug;
  const mod = slug ? findModuleBySlug(slug, true) : null;

  return (
    <div
      className="min-h-[70vh] flex items-center justify-center px-4 py-10"
      data-testid="access-denied-page"
    >
      <div className="max-w-xl w-full bg-white rounded-2xl shadow-sm border border-slate-200 p-8 md:p-10 text-center">
        <div className="mx-auto w-16 h-16 rounded-full bg-amber-50 border border-amber-200 flex items-center justify-center mb-5">
          <ShieldWarning size={30} weight="duotone" className="text-amber-600" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">
          Bu modüle erişim yetkiniz bulunmuyor
        </h1>
        {mod ? (
          <p className="text-slate-600 mb-1">
            <span className="font-semibold text-slate-800">{mod.title}</span>{" "}
            modülüne erişebilmek için yetkilendirme gereklidir.
          </p>
        ) : (
          <p className="text-slate-600 mb-1">
            Bu sayfaya erişebilmek için yetkilendirme gereklidir.
          </p>
        )}
        <p className="text-slate-500 mb-7 flex items-center justify-center gap-2 text-sm">
          <EnvelopeSimple size={16} weight="duotone" />
          Lütfen sistem yöneticinize danışın.
        </p>
        <div className="flex items-center justify-center gap-3">
          <Button
            onClick={() => nav("/", { replace: true })}
            className="bg-[#1B4776] hover:bg-[#163a63] text-white"
            data-testid="access-denied-home-btn"
          >
            <House size={18} weight="duotone" className="mr-2" />
            Ana Sayfaya Dön
          </Button>
          <Button
            variant="outline"
            onClick={() => nav(-1)}
            data-testid="access-denied-back-btn"
          >
            Geri
          </Button>
        </div>
      </div>
    </div>
  );
}
